module.exports = __webpack_public_path__ + "static/media/cape_cod.5c18e54e.jpeg";